import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {OccEndpointsService, Product, ProductSearchPage} from '@spartacus/core';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {ActiveCartFacade} from '@spartacus/cart/base/root';
import {ProductService} from '@dcp/configurator';
import {PRODUCT_SEARCH_FIELDS, VARIANT_PRODUCT_SEARCH_FIELDS} from '@app/config/ProductSearchFieldsConfig';

@Injectable({
  providedIn: 'root'
})
export class DcpProductService extends ProductService {

  constructor(
    protected http: HttpClient,
    protected occEndpointsService: OccEndpointsService,
    protected activeCartFacade: ActiveCartFacade,
  ) {
    super(http, occEndpointsService, VARIANT_PRODUCT_SEARCH_FIELDS, PRODUCT_SEARCH_FIELDS);
  }

  /**
   * Fetch recently added products
   */
  public fetchRecentlyAddedProducts(): Observable<ProductSearchPage> {
    const params: HttpParams = new HttpParams()
      .set('fields', 'products(code,name,summary,price(FULL),images(FULL),classifications,transactionTypes,trial),facets')
      .set('sort', 'createdat-desc');
    return this.searchForProducts(params);
  }

  /**
   * Fetch popular products by product codes
   */
  public fetchPopularProductsByProductCodes(productCodes: string[]): Observable<ProductSearchPage> {
    if (productCodes && productCodes.length) {
      let params: HttpParams = new HttpParams()
        .set('fields', 'products(code,name,summary,price(FULL),images(FULL),classifications,transactionTypes,trial),facets')
        .set('sort', 'relevance');
      let query: string = ':relevance:';
      productCodes.forEach((productCode) => {
        query += `code:${productCode}:`;
      });
      params = params.set('query', query);
      return this.searchForProducts(params);
    }
    return of({products: []});
  }

  public fetchTotalResultsForCategory(categoryId: string): Observable<ProductSearchPage> {
    let params: HttpParams = new HttpParams()
      .set('fields', 'products()');
    if (categoryId) {
      params = params.set('query', `:relevance:category:${categoryId}`);
    }
    return this.searchForProducts(params);
  }

  /**
   * Searches for products
   */
  public searchForProducts(params: HttpParams): Observable<ProductSearchPage> {
    const apiUrl: string = this.occEndpointsService.buildUrl('/products/search');
    return this.http.get<any>(apiUrl, {params});
  }

  public getProductDetailsByCode(productCode: string): Observable<{
    displayProduct: Product,
    editionProduct: Product
  }> {
    return this.http.get<any>(this.occEndpointsService.buildUrl(`/products/entitlement/${productCode}?fields=DEFAULT`))
  }

  isProductInCart(supplierAlternativeAID: string): Observable<boolean> {
    return this.activeCartFacade.getActive().pipe(map(cart => {
      if (cart && cart.entries) {
        return cart.entries.some(entry => entry.product.supplierAlternativeAID === supplierAlternativeAID);
      }
      return false;
    }));
  }
}
